export default "__VITE_ASSET__BGgPMf43__"